/**
 * Please prefix every variable name with `CACHE_KEY_` so developers can easily
 * discover available keys with TS auto-import suggestions.
 *
 * So, if you create a `hooks/data/yabbaDabba.ts` the key const variable name here should
 * be `CACHE_KEY_YABBA_DABBA` and it's value should be `yabbaDabba`.
 *
 * If you're thinking: "Why not use `module.filename`?" wellll that doesn't work in dev server.
 */

export const CACHE_KEY_DELIVERY_ADDRESS = 'deliveryAddress';
export const CACHE_KEY_HOME_BANNER = 'homeBanner';
export const CACHE_KEY_ORDER = 'order';
export const CACHE_KEY_OTC = 'otc';
export const CACHE_KEY_PHARMAKON_ACCOUNT = 'pharmakon.account';
export const CACHE_KEY_PHARMAKON_FACILITY_BY_ACCOUNT = 'pharmakon.facilityByAccount';
export const CACHE_KEY_PHARMAKON_PATIENT_LIST = 'pharmakon.patient';
export const CACHE_KEY_PHARMAKON_PAYMENT_CARD_LIST = 'pharmakon.paymentCardList';
export const CACHE_KEY_PHARMAKON_PENDING_PRESCRIPTION_TRANSFER = 'pharmakon.pendingPrescriptionTransfer';
export const CACHE_KEY_PHARMAKON_V3_ACTIVE_PENDING_MEDS = 'pharmakon.v3.active_pending_meds';
export const CACHE_KEY_PHARMAKON_V3_ARCHIVED_MEDS = 'pharmakon.v3.archived_medications';
export const CACHE_KEY_PHARMAKON_V3_PENDING_TRANSFERS = 'pharmakon.v3.pending_transfers';
export const CACHE_KEY_PHARMAKON_V3_USER = 'pharmakon.v3.user';
export const CACHE_KEY_PHARMACY_HUB_ENTRY_ID = 'pharmacy_hub_entry_id';
export const CACHE_KEY_PHARMACY_HUB_SHORT_CODE = 'pharmacy_hub_short_code';
export const CACHE_KEY_PRESCRIPTION = 'prescription';
export const CACHE_KEY_ZIP_CODE_DELIVERABLE = 'zipCode';
export const CACHE_KEY_ACTIVATE_EXPERIMENT = 'bff.active_experiment';
export const CACHE_KEY_DEEPLINK_FOR_ADD_ADOPTION = 'bff.deeplink';
export const CACHE_KEY_PHARMACY_SEARCH = 'bff.pharmacy.search';
export const CACHE_KEY_PHARMACY_PHOTO = 'bff.pharmacy.photo';
export const CACHE_KEY_PHARMACY_DETAILS = 'bff.pharmacy.details';
export const CACHE_KEY_FACILITY_BY_ZIPCODE = 'bff.facility_by_zipcode';
export const CACHE_KEY_PRESCRIPTION_TRANSFER_CANDIDATES = 'bff.prescription_transfer_candidates';
export const CACHE_KEY_PRESCRIPTION_TRANSFER_CANDIDATES_WITH_CAPSULE_MEDS =
  'bff.prescription_transfer_candidates_with_capsule_meds';
export const CACHE_KEY_HEALTH_PROFILE_MESSAGE_HISTORY = 'bff.health_profile_message_history';
export const CACHE_KEY_HEALTH_PROFILE_MEDICATIONS_TO_VERIFY = 'bff.health_profile_medications_to_verify';
export const CACHE_KEY_HEALTH_PROFILE_IS_UPDATE_DUE = 'bff.health_profile_is_update_due';
